import { ExtraService } from '../core/services/extra.service';
import { NewPageService } from '../templates/new-page/service/new-page.service';
import { ComponentFactoryResolver } from '@angular/core';
import { NewPageList } from '../core/models/new-page-list';
import { DropDownComponent } from '../layout/drop-down/drop-down.component';
import { ListWithinList } from '../core/models/list-within-list';
import { ContentsMandatory } from '../core/models/contents-mandatory';
import { ProfileImageUpload } from '../core/models/profile-image-upload';
import { Constants } from '../core/config/Constants';
import { Sponsors } from '../core/models/sponsors';
import { MultiUtilityService } from '../core/services/multi-utility.service';
import { Exhibitor } from '../core/models/exhibitor';
import { Organizer } from '../core/models/organizer';
import { Speaker } from '../core/models/speaker';

export class MultiUtility {

  //XYZ - Dependency in Sponsor-add-new.ts file --> Already explained, it's due to inheritance
  extraService: ExtraService;
  newPageService: NewPageService;
  _cfr: ComponentFactoryResolver;

  public errorMessage: string[];
  public isError: boolean = false;
  public confirmMessage: string = '';
  public disableButton = true;

  public bannerUploadProgress;
  public iconUploadProgress;
  //todo

  constructor(private multiUtilityService: MultiUtilityService,
    extraService: ExtraService,
    newPageService: NewPageService,
    _cfr: ComponentFactoryResolver) {

    this.extraService = extraService;
    this.newPageService = newPageService;
    this._cfr = _cfr;
  }

  public initComponentThings() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
  }


  public getCategoryItemName(eventId: string, categoryListType: string, categoryId: string) {
    return this.multiUtilityService.getCategoryItemName(eventId, categoryListType, categoryId);
  }

  public aboutListUp(componentName, dropDown) {
    this.newPageService.up$.subscribe(data => {
      if (data != null) {
        let index = componentName.aboutList.indexOf(data);
        if (index > 0) {
          this.swap(index, index - 1, componentName, dropDown);
        }
      }
    });
  }

  public aboutListDown(componentName, dropDown) {
    this.newPageService.down$.subscribe(data => {
      if (data != null) {
        let index = componentName.aboutList.indexOf(data);
        if (index < componentName.aboutList.length - 1) {
          this.swap(index, index + 1, componentName, dropDown);
        }
      }
    });
  }

  public aboutListRemove(componentName) {
    this.newPageService.remove$.subscribe(data => {
      if (data != null) {
        let index = componentName.aboutList.indexOf(data);
        if (index != -1) {
          this.remove(index, componentName);
        }
      }
    });
  }

  public swap(index1, index2, componentName, dropDown) {
    dropDown.move(dropDown.get(index1), index2);
    let data = componentName.aboutList[index1];
    componentName.aboutList[index1] = componentName.aboutList[index2];
    componentName.aboutList[index2] = data;
  }

  public remove(index, componentName) {
    componentName.aboutList = componentName.aboutList.filter((val, i) => i != index);
  }

  public showDropDown(dropDown, componentName, eventId) {
    let aboutUs = new NewPageList();
    let dropDown2 = this._cfr.resolveComponentFactory(DropDownComponent);
    let expComponent = dropDown.createComponent(dropDown2);
    componentName.aboutList.push(aboutUs);
    expComponent.instance.eventId = eventId;
    expComponent.instance.show = true;
    expComponent.instance._ref = expComponent;
    expComponent.instance.aboutUs = componentName.aboutList[componentName.aboutList.length - 1];
  }

  public addComponent(about: NewPageList, dropDown2, eventId) {
    let dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
    let expComponent = dropDown2.createComponent(dropDown);
    expComponent.instance.eventId = eventId;
    expComponent.instance._ref = expComponent;
    expComponent.instance.aboutUs = about;
    if (about.type == 'text') {
      expComponent.instance.addTextBox();
    } else if (about.type == 'list') {
      expComponent.instance.addList();
    } else {
      expComponent.instance.addStatic(about.type);
    }
  }

  //XYZ --> ???
  validate(componentName) {
    let valid = true;
    componentName.aboutList.forEach(element => {
      if (element.type == 'text' && (element.text == null || element.text.trim().length < 1)) {
        if (this.errorMessage.indexOf('Text cannot empty') == -1) {
          this.errorMessage.push('Text cannot empty');
        }
        valid = false;
      }
      if (element.type == 'list' && (element.listWithinListList == null || element.listWithinListList.length < 1)) {
        if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
          this.errorMessage.push('Add atleast one list item');
        }
        valid = false;
      } else if (element.type == 'list' && element.listWithinListList.length == 1 && element.listWithinListList[0].hasSubList == null) {
        if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
          this.errorMessage.push('Add atleast one list item');
        }
        valid = false;
      } else if (element.type == 'list' && element.listWithinListList != null && element.listWithinListList.length > 0) {
        element.listWithinListList.forEach(subList => {
          let bool = this.validateList(subList);
          if (!bool) {
            valid = false;
          }
        });
      }
      if (element.type == null || element.type.trim().length < 1) {
        this.remove(componentName.aboutList.indexOf(element), componentName);
      }

    });
    if (componentName.name == null || componentName.name.length < 3) {
      this.isError = true;
      valid = false;
      this.errorMessage.push('Name is not valid');
    }
    return valid;
  }

  validateList(listWithinList: ListWithinList): boolean {
    let valid = true;
    if ((listWithinList.hasSubList != null && (listWithinList.text == null || listWithinList.text.length < 1))) {
      if (this.errorMessage.indexOf('list field cannot empty') == -1) {
        this.errorMessage.push('list field cannot empty');
      }
      valid = false;
    }
    if (listWithinList.hasSubList && listWithinList.listWithinListList != null && listWithinList.listWithinListList.length > 0) {
      listWithinList.listWithinListList.forEach(subList => {
        valid = this.validateList(subList);
      });
    }
    return valid;
  }

  uploadImageToStorage2(imageFile: File, firebase, eventId: string, cmType: string) {

  }


  //XYZ - Why are all types Any? Explain parameter. CONTENT_M_TYPE_SPONSORS is static!!
  uploadImageToStorage(imageFile: File, firebase, sponsor, eventId: string, cmType: string, imgType: string) {
    this.confirmMessage = null;

    if (sponsor instanceof Sponsors) {
      console.log("This is a Spo");
    } else if (sponsor instanceof Exhibitor) {
      console.log("This is a Exhibitor");
    } else if (sponsor instanceof Organizer) {
      console.log("This is a Organizer");
    }

    // if (sponsor typeof Sponsors) {
    //   console.log("This is a Spo");
    // } else if (sponsor instanceof Exhibitor) {
    //   console.log("This is a Exhibitor");
    // } else if (sponsor instanceof Organizer) {
    //   console.log("This is a Organizer");
    // }

    if (imageFile != null) {


      // imgType === Constants.IMAGE_UPLOAD_TYPE_LOGO ? (sponsor.logoName = imageFile.name) : (sponsor.iconName = imageFile.name);

      // imageFileUpload = new ProfileImageUpload(imageFile);
      //XYZ - should be a separate service --> Done
      let uploadTask = this.multiUtilityService.pushUpload(new ProfileImageUpload(imageFile), eventId, cmType);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          this.disableButton = false;
          this.confirmMessage = 'File uploading...';
          let progres = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100);

          // if (sponsor instanceof Sponsors) {

          //   imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (this.logoUploadProgress = progres) : (this.iconUploadProgress = progres);
          // } else if (sponsor instanceof Exhibitor || sponsor instanceof Organizer) {
          imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (this.bannerUploadProgress = progres) : (this.iconUploadProgress = progres);

          // }
        },
        (error) => {
          this.errorMessage.push(error.message);
          this.isError = true;
        },
        () => {
          // imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (sponsor.logoUrl = uploadTask.snapshot.downloadURL) : (sponsor.iconUrl = uploadTask.snapshot.downloadURL);

          let contentsMandatory = new ContentsMandatory();
          contentsMandatory.category = cmType;
          contentsMandatory.eventId = eventId;
          contentsMandatory.filename = imageFile.name;
          contentsMandatory.extension = imageFile.type.split('/').pop();
          contentsMandatory.sizeInBytes = imageFile.size;
          //XYZ - should be a separate service
          let key = this.multiUtilityService.addContentMandatory(contentsMandatory);
          if (key) {

            if (sponsor instanceof Sponsors) {
              sponsor = <Sponsors>sponsor;
              // imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (sponsor.logoName = imageFile.name) : (sponsor.iconName = imageFile.name);

              if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
                sponsor.iconName = imageFile.name;
                sponsor.iconUrl = uploadTask.snapshot.downloadURL;
                sponsor.iconCMId = key;
              } else if (imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER) {
                sponsor.bannerName = imageFile.name;
                sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
                sponsor.bannerCMId = key;
              }


            } else if (sponsor instanceof Exhibitor) {
              sponsor = <Exhibitor>sponsor;
              if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
                sponsor.iconName = imageFile.name;
                sponsor.iconUrl = uploadTask.snapshot.downloadURL;
                sponsor.iconCMId = key;
              } else {
                sponsor.bannerName = imageFile.name;
                sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
                sponsor.bannerCMId = key;
              }
            } else if (sponsor instanceof Organizer) {
              sponsor = <Organizer>sponsor;
              if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
                sponsor.iconName = imageFile.name;
                sponsor.iconUrl = uploadTask.snapshot.downloadURL;
                sponsor.iconCMId = key;
              } else {
                sponsor.bannerName = imageFile.name;
                sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
                sponsor.bannerCMId = key;
              }
            } else if (sponsor instanceof Speaker) {
              sponsor = <Speaker>sponsor;
              // if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
              // sponsor.iconName = imageFile.name;
              sponsor.profileImageUri = uploadTask.snapshot.downloadURL;
              sponsor.fileCMId = key;
              // } else {
              //   sponsor.bannerName = imageFile.name;
              //   sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
              //   sponsor.bannerCMId = key;
              // }
            }

            imageFile = null;
            this.disableButton = true;
            this.confirmMessage = 'File Uploaded Successfully';
          }
        }
      );
    }
  }
  uploadImageToStoragePromise(imageFile: File, firebase, sponsor, eventId: string, cmType: string, imgType: string) {
    return new Promise((resolve, reject)=>{

      let uploadUrl = "";
      this.confirmMessage = null;

      if (sponsor instanceof Sponsors) {
        console.log("This is a Sponsor");
      } else if (sponsor instanceof Exhibitor) {
        console.log("This is a Exhibitor");
      } else if (sponsor instanceof Organizer) {
        console.log("This is a Organizer");
      }
  
      // if (sponsor typeof Sponsors) {
      //   console.log("This is a Spo");
      // } else if (sponsor instanceof Exhibitor) {
      //   console.log("This is a Exhibitor");
      // } else if (sponsor instanceof Organizer) {
      //   console.log("This is a Organizer");
      // }
  
      if (imageFile != null) {
  
  
        // imgType === Constants.IMAGE_UPLOAD_TYPE_LOGO ? (sponsor.logoName = imageFile.name) : (sponsor.iconName = imageFile.name);
  
        // imageFileUpload = new ProfileImageUpload(imageFile);
        //XYZ - should be a separate service --> Done
        let uploadTask = this.multiUtilityService.pushUpload(new ProfileImageUpload(imageFile), eventId, cmType);
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
          (snapshot) => {
            this.disableButton = false;
            this.confirmMessage = 'File uploading...';
            let progres = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100);
  
            // if (sponsor instanceof Sponsors) {
  
            //   imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (this.logoUploadProgress = progres) : (this.iconUploadProgress = progres);
            // } else if (sponsor instanceof Exhibitor || sponsor instanceof Organizer) {
            imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (this.bannerUploadProgress = progres) : (this.iconUploadProgress = progres);
  
            // }
          },
          (error) => {
            this.errorMessage.push(error.message);
            this.isError = true;
          },
          () => {
            // imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (sponsor.logoUrl = uploadTask.snapshot.downloadURL) : (sponsor.iconUrl = uploadTask.snapshot.downloadURL);
            
            let contentsMandatory = new ContentsMandatory();
            contentsMandatory.category = cmType;
            contentsMandatory.eventId = eventId;
            contentsMandatory.filename = imageFile.name;
            contentsMandatory.extension = imageFile.type.split('/').pop();
            contentsMandatory.sizeInBytes = imageFile.size;
            uploadUrl += `${eventId}/${cmType}/${imageFile.name}`;
            //XYZ - should be a separate service
            let key = this.multiUtilityService.addContentMandatory(contentsMandatory);
            if (key) {
  
              if (sponsor instanceof Sponsors) {
                sponsor = <Sponsors>sponsor;
                // imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER ? (sponsor.logoName = imageFile.name) : (sponsor.iconName = imageFile.name);
  
                if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
                  sponsor.iconName = imageFile.name;
                  sponsor.iconUrl = uploadTask.snapshot.downloadURL;
                  sponsor.iconCMId = key;
                } else if (imgType === Constants.IMAGE_UPLOAD_TYPE_BANNER) {
                  sponsor.bannerName = imageFile.name;
                  sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
                  sponsor.bannerCMId = key;
                }
  
  
              } else if (sponsor instanceof Exhibitor) {
                sponsor = <Exhibitor>sponsor;
                if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
                  sponsor.iconName = imageFile.name;
                  sponsor.iconUrl = uploadTask.snapshot.downloadURL;
                  sponsor.iconCMId = key;
                } else {
                  sponsor.bannerName = imageFile.name;
                  sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
                  sponsor.bannerCMId = key;
                }
              } else if (sponsor instanceof Organizer) {
                sponsor = <Organizer>sponsor;
                if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
                  sponsor.iconName = imageFile.name;
                  sponsor.iconUrl = uploadTask.snapshot.downloadURL;
                  sponsor.iconCMId = key;
                } else {
                  sponsor.bannerName = imageFile.name;
                  sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
                  sponsor.bannerCMId = key;
                }
              } else if (sponsor instanceof Speaker) {
                sponsor = <Speaker>sponsor;
                // if (imgType === Constants.IMAGE_UPLOAD_TYPE_ICON) {
                // sponsor.iconName = imageFile.name;
                sponsor.profileImageUri = uploadTask.snapshot.downloadURL;
                sponsor.fileCMId = key;
                // } else {
                //   sponsor.bannerName = imageFile.name;
                //   sponsor.bannerUrl = uploadTask.snapshot.downloadURL;
                //   sponsor.bannerCMId = key;
                // }
              }
  
              imageFile = null;
              this.disableButton = true;
              this.confirmMessage = 'File Uploaded Successfully';
              resolve({
                url: uploadUrl
              });
            }
          }
        );
      }

    })
   
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/shared/multi-utility.ts